var map = {
	"./11 2.png": "3a73",
	"./11.png": "e509",
	"./1111.png": "6aa0",
	"./4.jpg": "ab86",
	"./5.jpg": "4e68",
	"./6.jpg": "7220",
	"./7.jpg": "de17",
	"./LOGO.png": "c070",
	"./MasterCard.png": "58a4",
	"./VISA-logo 1.png": "7276",
	"./VISA-logo.png": "f84d",
	"./beneficios.jpg": "0895",
	"./beneficios2.jpg": "b309",
	"./bk.png": "d9d7",
	"./charman2.png": "b991",
	"./charman3.png": "5b2b",
	"./check.png": "06fb",
	"./cisco.png": "9f26",
	"./cisco_network_academy_app.jpg": "f7aa",
	"./cordoba.png": "26fb",
	"./coronavirus_spanish.jpg": "9cf4",
	"./correo.png": "deb8",
	"./datacenter.jpg": "47bd",
	"./emprendimiento.jpg": "2974",
	"./fotos-webnic/00303.MTS_snapshot_00.08.303 (1).jpg": "9760",
	"./fotos-webnic/1 test 2022 (1).jpg": "65f3",
	"./fotos-webnic/20190314_084716 (1).jpg": "418b",
	"./fotos-webnic/20190318_103536 (1).jpg": "29ef",
	"./fotos-webnic/20190318_103700 (1).jpg": "711d",
	"./fotos-webnic/20220106_102836 (1).jpg": "43f4",
	"./fotos-webnic/20220107_080836 (1).jpg": "11ff",
	"./fotos-webnic/20220107_103746 (1).jpg": "84b4",
	"./fotos-webnic/20220107_103958 (1).jpg": "f1b0",
	"./fotos-webnic/DSC_0233 (1).JPG": "1ed9",
	"./fotos-webnic/IMG_0882 (1).JPG": "c6a0",
	"./fotos-webnic/IMG_0883 (1).JPG": "d8ce",
	"./fotos-webnic/IMG_0884 (1).JPG": "9b71",
	"./fotos-webnic/IMG_20210226_103209 (1).jpg": "d3c9",
	"./fotos-webnic/IMG_8542 (1).JPG": "c82f",
	"./fotos-webnic/IMG_8584 (1).JPG": "03b3",
	"./fotos-webnic/UNI 3ra Convocatoria de Cursos  (1) (1).JPG": "d486",
	"./fotos-webnic/UNI 3ra Convocatoria de Cursos  (242) (1).JPG": "e3b4",
	"./fotos-webnic/UNI 3ra Convocatoria de Cursos  (252) (1).JPG": "0c39",
	"./fotos-webnic/UNI 3ra Convocatoria de Cursos  (253) (1).JPG": "8215",
	"./fotos-webnic/UNI 3ra Convocatoria de Cursos  (270) (1).JPG": "b83c",
	"./fotos-webnic/UNI Segunda sesión para convocatoria 2020(69) (1).JPG": "1183",
	"./get-conected.jpg": "6c5f",
	"./iana.png": "460b",
	"./iana2.png": "96df",
	"./icann.png": "35da",
	"./iniciar-sesion.png": "0477",
	"./internet-society-isoc.png": "58d9",
	"./internet.png": "e310",
	"./iot.png": "8a35",
	"./lacnic.png": "8228",
	"./lacnic.svg": "a0c6",
	"./login-register.jpg": "680f",
	"./login.jpg": "4424",
	"./login123.png": "ec83",
	"./login1234.png": "98ab",
	"./login2.jpg": "df37",
	"./login32.png": "6b39",
	"./login89.png": "f3ee",
	"./loginbg.jpg": "281e",
	"./logo.jpg": "aca7",
	"./logoNiCircle.png": "0920",
	"./logoNic.png": "36ca",
	"./logouni12.png": "c798",
	"./mas.png": "4660",
	"./master-cut.jpg": "79b8",
	"./master21.png": "bf85",
	"./nic-ni-logo.svg": "bc24",
	"./pago.png": "e256",
	"./palacio.jpg": "27fe",
	"./pass.png": "3fc6",
	"./proteger.png": "db7c",
	"./questions.png": "8e40",
	"./red.png": "94f9",
	"./register.png": "7d6c",
	"./register01.png": "6174",
	"./security.jpg": "ce48",
	"./stepchar1.png": "a084",
	"./stepchar3.png": "9c61",
	"./team.jpg": "1efd",
	"./teatro.jpg": "ea0d",
	"./tiscapa.jpg": "bd63",
	"./ventajas principal.jpg": "1c96",
	"./visa-cut.jpg": "b7ab",
	"./visa-cut2.jpg": "6506",
	"./visa.png": "073b",
	"./volcan.jpg": "155f",
	"./whois-team.jpg": "a6e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";